<template>
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <div class="text-center pr-10">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon size="19">mdi-bell-off</v-icon>
        </v-btn>
      </div>
    </template>

    <div class="bg-white text-center font-13 px-2 py-3 w-200 text-center">
      <p class="ma-0" v-text="`Produto silenciado na filial ${item.filial}, por isso esta desativado para compra.`" />

      <v-btn text small color="primary" class="mt-1" @click="item.edicao_bloqueada = false">
        ativar para compra
      </v-btn>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: "ProdutoSilenciado",
  props: {
    item: Object
  }
}
</script>

<style scoped>

</style>
